import { formatIQD } from '../../../shared/format.js';

export function ProductTile({ product, onAdd }) {
  // بند بلا مخزون (خدمة): يُباع دائماً ولا معنى لعرض «نفد» أو الكمية المتوفرة.
  const tracksStock = product.tracksStock !== false;
  const stock = Number(product.currentStock) || 0;
  const min = Number(product.minStockAlert) || 0;
  const outOfStock = tracksStock && stock <= 0;
  const low = tracksStock && !outOfStock && stock <= min;
  const emoji = product.emoji || '📦';

  return (
    <button
      type="button"
      disabled={outOfStock}
      onClick={() => onAdd(product)}
      className="relative bg-white border border-line rounded-[14px] p-3 text-center shadow-card hover:bg-paper-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      style={{ minHeight: 132 }}
    >
      {low ? (
        <div className="absolute top-1.5 right-1.5 bg-[#FEF3C7] text-[#92400E] px-1.5 py-0.5 rounded-md text-[9px] font-bold">
          ⚠ مخزون منخفض
        </div>
      ) : null}
      {outOfStock ? (
        <div className="absolute top-1.5 right-1.5 bg-[#FEE2E2] text-[#B91C1C] px-1.5 py-0.5 rounded-md text-[9px] font-bold">
          نفد
        </div>
      ) : null}
      {!tracksStock ? (
        <div className="absolute top-1.5 right-1.5 bg-[#E0F2FE] text-[#0369A1] px-1.5 py-0.5 rounded-md text-[9px] font-bold">
          خدمة
        </div>
      ) : null}
      <div className="text-[40px] leading-none">{emoji}</div>
      <div className="text-[13px] font-bold mt-2 line-clamp-2 min-h-[34px]">{product.name}</div>
      <div className="text-orange-deep font-bold mt-1">{formatIQD(product.salePrice)}</div>
      <div className="text-ink-3 text-[10.5px] mt-0.5">
        {tracksStock ? `${stock} متوفر` : 'بدون مخزون'}
      </div>
    </button>
  );
}
